import React from 'react';
import {Badge, Button, Col, Form, Row} from 'react-bootstrap';
import moment from 'moment';
import PropTypes from 'prop-types';
import {lifecycleStates} from '../../../../shared/constants/lifecycleStates';
import {useLifecycle} from '../../hooks/useLifecycle';
import {Dropdown} from '../../../../shared/ui/Dropdown';

const Lifecycle = ({eid}) => {
  const {
    loading,
    selectedLifecycle,
    setSelectedLifecycle,
    comment,
    setComment,
    lifecycleHistory,
    updateStatus,
  } = useLifecycle(eid);

  const historyHeight = 4 * 41;

  return (
    <div className="island p-0 overflow-hidden h-100 d-flex flex-column">
      <div className="p-3" style={{borderBottom: '1px solid var(--border-color)', flexShrink: 0}}>
        <Row className="g-2 align-items-center">
          <Col md={3}>
            <Dropdown
              options={Object.keys(lifecycleStates).map((key) => ({value: key, label: key}))}
              value={selectedLifecycle}
              onChange={(val) => setSelectedLifecycle(val)}
              size="sm"
              block
            />
          </Col>
          <Col>
            <Form.Control
              type="text"
              placeholder="Reason for change..."
              value={comment}
              size="sm"
              onChange={(e) => setComment(e.target.value)}
              style={{
                backgroundColor: 'var(--input-bg)',
                color: 'var(--text-primary)',
                borderColor: 'var(--border-color)',
              }}
            />
          </Col>
          <Col xs="auto">
            <Button
              onClick={updateStatus}
              disabled={loading}
              size="sm"
              style={{backgroundColor: 'var(--blue)', borderColor: 'var(--blue)', whiteSpace: 'nowrap'}}
            >
              {loading ? 'Saving...' : 'Update'}
            </Button>
          </Col>
        </Row>
      </div>
      <div style={{minHeight: historyHeight, overflowY: 'auto', maxHeight: historyHeight, flex: 1}}>
      {lifecycleHistory.length === 0 ? (
        <p className="small text-center py-3 mb-0" style={{color: 'var(--text-secondary)'}}>No history recorded yet.</p>
      ) : (
        lifecycleHistory.map((l, idx) => (
          <div
            key={l.created?.seconds || idx}
            className="px-3 py-2 d-flex align-items-center justify-content-between"
            style={{borderBottom: idx === lifecycleHistory.length - 1 ? 'none' : '1px solid var(--border-color)'}}
          >
            <div className="d-flex align-items-center gap-2">
              <Badge bg={lifecycleStates[l.status] || 'secondary'} className="px-2 py-1">
                {l.status}
              </Badge>
              {l.comment && (
                <span className="small" style={{color: 'var(--text-secondary)'}}>{l.comment}</span>
              )}
            </div>
            <span className="small" style={{color: 'var(--text-secondary)', whiteSpace: 'nowrap', marginLeft: 12}}>
              {l.created ? moment(l.created.toDate()).format('DD.MM.YYYY HH:mm') : '-'}
            </span>
          </div>
        ))
      )}
      </div>
    </div>
  );
};

Lifecycle.propTypes = {
  eid: PropTypes.string.isRequired,
};

export default Lifecycle;
